import * as React from "react";
import {
  Avatar as ShellAvatar,
  initialsFromUser,
} from "../../../taskpane/components/primitives/Avatar";

export type AvatarProps = {
  name: string;
  size?: number;
  fontSize?: number;
  /** Visible ring for stacked avatars (works in light + dark). */
  ring?: boolean;
};

/** Clean monochrome initials avatar — matches clm-redesign WordPlugin. */
const Avatar: React.FC<AvatarProps> = ({ name, size = 24, fontSize, ring = false }) => {
  const who = initialsFromUser(name);
  return (
    <span
      className={`collaborate-avatar${ring ? " collaborate-avatar--ring" : ""}`}
      style={{ width: size, height: size }}
    >
      <ShellAvatar who={who} size={size} fontSize={fontSize ?? size * 0.4} name={name} />
    </span>
  );
};

export default Avatar;
